import { render } from "./Bonus.vue?vue&type=template&id=752b1b29&ts=true"
import script from "./Bonus.vue?vue&type=script&lang=ts"
export * from "./Bonus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__